// * Bootstrap libraries
import './_bootstrap';

// * Any other global site-wide JavaScript should be placed below.

/*

jQuery(document).ready(function(){

    jQuery('.block-better-social-sharing-buttons').click(function() {
         if (this.classList.contains('opened')) {
            jQuery('.block-better-social-sharing-buttons').removeClass("opened");
        } 
        else {
            jQuery('.block-better-social-sharing-buttons').addClass("opened");
        }
    });

});

*/

jQuery(document).ready(function() {

    var $sharingButton = jQuery('.block-better-social-sharing-buttons');

    // Toggle the "opened" class when clicking the button
    $sharingButton.click(function(event) {
        event.stopPropagation(); // Prevent the click from bubbling up to the document
        $sharingButton.toggleClass('opened');
    });

    // Listen for clicks on the document
    jQuery(document).click(function(event) {
        // Check if the clicked element is not the sharing button or inside it
        if (!jQuery(event.target).closest('.block-better-social-sharing-buttons').length) {
            $sharingButton.removeClass('opened');
        }
    });


    // read more for more than 300 words in a descreption
/*
    jQuery('.moreinfo').hide();
    jQuery('.more').click(function (ev) {
        var t = ev.target
        jQuery('#info' + jQuery(this).attr('target')).toggle(500, function(){
            //console.log(ev.target)
            jQuery(t).html(jQuery(this).is(':visible')? 'Show less <i class="fa fa-angle-double-up" aria-hidden="true"></i>' : 'Read more <i class="fa fa-angle-double-down" aria-hidden="true"></i>')
        });

        jQuery('.discription-teaser').toggle();
        return false;
    });
    */
    //test


    /*
    jQuery('.moreinfo').hide();

    jQuery('.more').click(function (ev) {
        ev.preventDefault(); // safer than return false
        var $link = jQuery(this); // always reference the anchor

        jQuery('#info' + $link.attr('target')).toggle(500, function () {
            if (jQuery(this).is(':visible')) {
                $link.html('Show less <i class="fa fa-angle-double-up" aria-hidden="true"></i>');
            } else {
                $link.html('Read more <i class="fa fa-angle-double-down" aria-hidden="true"></i>');
            }
        });

        jQuery('.discription-teaser').toggle();
    });
    */
jQuery(function ($) {
/*
    $('.moreinfo').hide();

    $('.more').on('click', function (e) {
        e.preventDefault();

        var $link = $(this);
        var $body = $link.closest('.body');
        var $info = $body.find('.moreinfo');
        var $teaser = $body.find('.discription-teaser');

        $info.slideToggle(500);
        $teaser.toggle();

        if ($info.is(':visible')) {
            $link.html('Show less <i class="fa fa-angle-double-up" aria-hidden="true"></i>');
        } else {
            $link.html('Read more <i class="fa fa-angle-double-down" aria-hidden="true"></i>');
        }
    }); */
    $('.moreinfo').hide();

$(document).on('click', '.more', function (e) {
    e.preventDefault();

    var $link = $(this);
    var $body = $link.closest('.body');
    var $info = $body.find('.moreinfo');
    var $teaser = $body.find('.discription-teaser');

    $info.slideToggle(500);
    $teaser.toggle();

    if ($link.hasClass('expanded')) {
        $link.removeClass('expanded');
        $link.html('Read more <i class="fa fa-angle-double-down" aria-hidden="true"></i>');
    } else {
        $link.addClass('expanded');
        $link.html('Show less <i class="fa fa-angle-double-up" aria-hidden="true"></i>');
    }
});

});
    //test


});
